export default {
  faq: {
    title: '常见问题',
    bookingProcess: {
      title: '订购流程',
      q1: '如何确认是否已完成订购呢？',
      a1: `当您预订完成，系统将发送订单确认信至您所登录的电子邮箱，烦请查收信内所附订单信息及凭证。如收到附有“使用电子票”链接的信件，可点击后直接使用。
  此外，您也可以点击信内的“订单详情”以确认您的订单信息。`,
      q2: '没有收到订单确认邮件，该怎么办呢？',
      a2: `当您订购"订购即时确认"的商品，订单将于约5分钟内被自动确认并发送订单确认信至您所登录的电子邮箱，若超过时间仍未收到订单确认信，烦请检查您的垃圾信件夹内是否有来自"@linktivity.co.jp"的信件。`,
      q3: '可以重新发行凭证吗？',
      a3: `可以，请按照以下步骤重新获取凭证：

1.登录您的账号后，点击右上角「我的主页」→「预订信息」。
2.在对应订单中点击「查看详情」。
3.在「凭证信息」栏确认凭证内容，并可点击「发送凭证」重新发送至您注册的电子邮箱。`
    },
    payments: {
      title: '支付',
      q1: '支付时出现了订购失败的讯息，该怎么办呢？',
      a1: `若发生此情形请先不要马上重新订购，请先于右上角的"帐户"点击"订单信息"，查看订单一览中是否有该订单的纪录，或烦请查收是否有收到订单确认信。若皆未能找到订单纪录，则烦请稍待约5分钟后再重新订购。`,
      q2: '可以给我收据吗？',
      a2: `抱歉目前无提供线上发行收据的服务，如需收据，烦请来信至客服邮箱<helpcenter@linktivity.co.jp>，并请注明您的订单编号、收据抬头、款项名称、金额等信息。`,
      q3: '可使用哪些支付方式呢？',
      a3: `您可使用信用卡进行支付（部分商品可使用Alipay、WeChat Pay支付）。恕无法使用便利店支付或现金支付。`,
      q4: '什么是3D验证？',
      a4: `3D验证为一种身份验证服务，可防止信用卡被盗刷等非法使用，提高持卡人在进行信用卡线上消费时的安全性。
  使用支援3D验证的信用卡进行支付时，会要求持卡人输入一次性密码进行身份验证（验证方式依信用卡公司而异）。`,
      q5: '该如何申请3D验证？ 我不知道自己的信用卡是否支援3D验证。',
      a5: `3D验证可在刷卡前向信用卡公司申请完成注册手续。
  如不清楚自己的信用卡是否支援3D验证，请洽询卡片背面的信用卡公司客服专线。 `,
      q6: `我不知道自己的3D验证密码。我没收到3D验证一次性密码。`,
      a6: `进行3D验证时所需的密码为事先向信用卡公司申请3D验证时所设定的密码，或是一次性密码。
  如未收到一次性密码，请检查您的垃圾邮件。
  如不清楚密码或是未收到一次性密码，请洽询卡片背面的信用卡公司客服专线。 `,
      q7: `只能使用已注册3D验证的信用卡吗？`,
      a7: `因近期信用卡盗刷事件剧增，日本经济产业省宣布预计于2025年3月下旬全面履行电子商务本人认证（EMV 3-D验证）义务化，恕本服务仅供已注册3D验证的信用卡可使用，敬请谅解。
  此外，于2023年3月发布的《信用卡安全指南【4.0版】》指出，将针对电子商务业者、信用卡公司（发卡公司、加盟店管理公司）及代理支付业者，全面履行“本人认证义务化及相关应对服务”。为符合上述准则，在新的预订平台上必须使用提供3D验证的支付系统。`,
      q8: `我可以使用借记卡吗？`,
      a8: `您可以使用借记卡。`,
      q9: '3D验证及额度均没问题、在其他网站上也可正常使用的信用卡，为什么会一直出现错误，无法支付？',
      a9: `如您的信用卡没有问题却无法支付，代表信用卡公司的支付审批系统可能发现有未经授权的使用纪录，并可能已取消支付以保护您的信用卡。
  此情况与人为判断不同，电脑会预测各种因素并根据该情况做出判断，而造成在特定时间内无法支付的可能性。
  如遇上述问题，可改尝试下述方法。
  ・使用不同的信用卡支付。
  ・过一段时间后再度尝试使用该信用卡支付。
  ・联络您的信用卡公司，说明您想订购的票券名称和情况，要求信用卡公司订正诈欺侦测和支付审批系统错误。`,
      q10: '我已收到信用卡公司的刷卡通知，但”我的帐户“中没有该订单信息，也没收到订购完成的电子邮件。',
      a10: `此情形可能为以下问题。
  ・电子邮箱输入错误（拼字错误等）。
  ・订购时输入的电子邮箱与平时使用的的电子邮箱不同。
  ・支付和订购未完成（信用卡额度没问题，但因某些错误导致支付和订购未完成）
  如您有订购时输入的某个电子邮箱印象，请尝试使用该邮箱登入“我的帐户”。
  如仍无法成功登入，请将下述信息与问题发送至LINKTIVITY客服中心<helpcenter@linktivity.co.jp>  ，由我们帮您查询您的支付和订购记录。
  -订购人姓名（英文拼音）：
  -活动参加日：
  -支付日期和时间（例：3/2 19:00）：
  -支付信用卡末3码 ：
  -支付信用卡有效期限：
  -总金额：
  -订购时可能输入的电子邮箱：`
    },
    changesAndCancellations: {
      title: '变更与取消',
      q1: '不小心订错了，该怎么取消呢？',
      a1: `若您订购的是可以取消的商品，请登入帐号后，依以下步骤取消：
  1.请于右上角的"帐户"点击"订单信息"。
  2.请于该订单点击"查看详情"。
  3.请于"取消信息"栏确认取消政策，并点击"开始取消"，确认取消费用后请点击"取消"即可取消订单。`,
      q2: '取消订单后何时可退款呢？',
      a2: `取消订单后，退款时间依您的信用卡公司而异，如欲确认具体的退款时间，烦请向您的信用卡公司咨询。`,
      q3: '可以变更订单吗？',
      a3: `烦请先取消原本的订单，再重新订购。由于是否可取消以及取消政策依商品而异，请先于商品页下方的取消政策栏确认。`
    },
    accounts: {
      title: '帐户',
      q1: '该如何注册帐号呢？',
      a1: `您可于网站右上角的"登入"进行注册，或于商品页上订购时亦可注册。由于近日常发生注册帐号时输入了错误邮箱的情形，注册帐号时烦请确认是否有输入正确的电子邮箱。
  此外，您亦可通过Facebook或Google等帐号登入使用本服务。`,
      q2: '该如何登入呢？',
      a2: `请于订购网站上的右上角点击"登入"即可开始登入您的帐户。`,
      q3: '忘记密码了该怎么办呢？',
      a3: `请于登入页面点击"忘记密码？"，依照页面指示的步骤重新设定密码。`,
      q4: '该如何删除帐号？',
      a4: `删除帐号方式如下：
  1.请于右上角的"帐户"点击"个人信息"。
  2.请点击右下角的"删除帐号"即可删除帐号。请注意，帐号删除后即不可继续使用本服务，如欲再次使用，烦请重新注册。`
    },
    environment: {
      title: '网络环境',
      q1: '使用本网站时该使用什么浏览器？',
      a1: `推荐使用以下浏览器：
  ・Firefox （最新版）
  ・Safari （最新版）
  ・Google Chrome （最新版）`,
      q2: '订单确认信是使用什么域名的邮箱发送的呢？',
      a2: `本服务的邮箱域名为"@linktivity.co.jp"，如有为预防垃圾邮件而设置电子邮件的网域限制，请于订购前事先将"@linktivity.co.jp"加入白名单。`
    },
    ticket: {
      title: '使用电子票',
      q1: '什么是一次性密码验证？',
      a1: `当您的链接环境（装置或浏览器等）发生变化时，为防止电子票遭第三者非法使用，本预订系统将会发送一次性密码（仅限一次有效的密码）供您验证。
  
  于不同的使用环境首次打开电子票时，系统将会发送一次性密码以供验证。
  为了确保使用当日可顺利使用电子票，建议您可先于活动当日使用的行动装置或浏览器上开启电子票，查阅内容。
  
  例：
  第一次开启电子票：A先生在自己的智能手机上开启电子票时，不需进行一次性密码验证。
  第二次开启电子票：A先生在家人的智能手机上开启电子票时，因与第一次开启电子票的行动装置不同，将会出现要求完成一次性密码验证画面。须完成验证。
  此时输入的电子邮箱将会被登录、固定于系统上。若第三次再以不同的行动装置开启电子票时，一次性密码将会发送至该邮箱。建议活动当日可先于邮箱内确认是否可收到一次性密码。`,
      q2: '我突然收到“您的链接环境已变化”信息。该如何出示电子票？',
      a2: `当您的链接环境发生变化（使用与第一次开启电子票的不同装置或浏览器开启电子票）时，须进行一次性密码验证。
  若出现上述讯息时，请先输入您欲收到一次性密码的电子邮箱。 ※建议输入可于活动当日现场查看一次性密码的电子邮箱，并确认该邮箱是否可收到一次性密码。
  当您收到邮件后，请输入正文内的一次性密码。如密码无误即验证完成，可显示您的电子票。`,
      q3: '我没收到一次性密码的电子邮件。',
      a3: `若超过时间仍未收到一次性密码邮件，烦请检查是否有在垃圾信件夹内。若您有限制网域，烦请将“@linktivity.co.jp”加至您的网域许可权。若已尝试过上述方法仍未收到电子邮件，可能是您输入的电子邮箱有误。烦请重新正确输入电子邮箱，或尝试输入其他的有效电子邮箱。`,
      q4: '我可以更改一次性密码的收件邮箱吗？',
      a4: `恕无法更改一次性密码的收件邮箱。一次性密码一经验证完成，之后的一次性密码皆会发送至您登录的电子邮箱内。建议您登录可于活动当日的行动装置（当日携带的智能手机等）上查看电子票的电子邮箱。`,
      q5: '我没购买任何商品却一直收到一次性密码的验证信，这是否为遭盗刷等非法使用？',
      a5: `若您一直收到一次性密码的验证信，可能为以下原因：
  ・您将电子票（凭证）转发给其他同行游客：
  若您的同行游客在您开启电子票、并完成一次性密码验证后开启电子票时，因使用的装置不同，系统将会向您发送一次性密码验证信。
  此时，因您的一次性密码收件邮箱（验证一次性密码时登录的邮箱）已被固定，每当您的同行游客连接电子票时，系统将会依该次数发送一次性密码验证信。
  ・非法使用：若您未将电子票转发给他人，则可能遭人盗用。请您深思熟虑，如有需要烦请重新订购。`,
      q6: '我收到由不明邮箱发送的一次性密码。',
      a6: `若您收到来自不明邮箱发送的一次性密码，可能为以下原因：
  ・您将电子票（凭证）转发给其他同行游客：
  若您在您的同行游客开启电子票、并完成一次性密码验证后开启电子票时，因使用的装置不同，系统将会向您发送一次性密码验证信。此时，一次性密码的收件邮箱已被固定为该同行游客的电子邮箱（验证一次性密码时登录的邮箱），系统将自动发送密码验证信至该邮箱。若遇此种情况，建议您可先询问您的同行游客。
  ・非法使用：若您未将电子票转发给他人，则可能遭人盗用。请您深思熟虑，如有需要烦请重新订购。`
    }
  }
};
